import React, { createContext, ReactNode, useContext, useState } from 'react';
import { format } from 'date-fns';
import { LanguageConstants } from '../../../utils/LanguageConstants';

interface ValesData {
  tipoLista: number;
  numOferta: string;
  fechaIniVigencia: any;
  fechaFinVigencia: string;
  fechaFinCanjeoDTO: string;
  fechaFinActivacion: string;
  fechaFinCanjeoPromo: string;
  visualizar: boolean;
  activable: boolean;
  gupoInternoVisualizar: string;
  grupoInternoActivacion: string;
  valeEAN: string;
  exclusividad: boolean;
  entregada: boolean;
  canjeada: boolean;
  activada: boolean;
  idioma: string;
  textoReclamo: string;
  textoTitulo: string;
  textoDescripcion1: string;
  textoDescripcion2: string;
  canalActivacion: string;
  canales: object;
  fechaActivacion: string;
  tipoVale: string;
  scoring: number;
  codImpacto: number;
  planAdhesion: number;
  denominacionPlanAdhesion: string;
  soportePostal: number;
  denominacionSoportePostal: string;
  valeDestacado: string;
  estructurasComerciales: object;
  tienda: string;
  fechaCanjeo: any;
  horaCanjeo: any;
  locale: string;
  preferencia: string;
  fechaInicioCanjeo: string;
  showValeEntrega: boolean;
  tipoReclamo: string;
  canalesVisualizacion: object;
  showPopup: boolean;
  masivo: boolean;
  numSecuencia?: string;
  fechaEmisionValeDigitalizado?: string;
  cantidadMinimaReclamo?: string;
  grupoIndex?: number;
}

export type ValesMasivosContextType = {
  cuponesMasivosActivables: any[];
  cuponesMasivosActivados: any[];
  cuponesMasivosCanjeados: any[];
  addCuponesMasivosActivables: (vale: any) => void;
  addCuponesMasivosActivados: (vale: any) => void;
  addCuponesMasivosCanjeados: (vale: any) => void;
  formaterFecha: (date: string, lenguage: string) => string;
  setCurrentCuponMasivoSelected: (vale: ValesData) => void;
  currentCuponMasivo: ValesData | null;
  resetcuponMasivo: () => void;
};

const ValesMasivosContext = createContext<ValesMasivosContextType | undefined>(
  undefined,
);

export const ValesMasivosProvider = ({ children }: { children: ReactNode }) => {
  const [cuponesMasivosActivables, setCuponesMasivosActivables] = useState<
    any[]
  >([]);
  const [cuponesMasivosActivados, setCuponesMasivosActivados] = useState<any[]>(
    [],
  );
  const [cuponesMasivosCanjeados, setCuponesMasivosCanjeados] = useState<any[]>(
    [],
  );
  const [
    currentCuponMasivo,
    setCurrentCuponMasivo,
  ] = useState<ValesData | null>(null);

  const addCuponesMasivosActivables = (cupones) =>
    setCuponesMasivosActivables(cupones);
  const addCuponesMasivosActivados = (cupones) =>
    setCuponesMasivosActivados(cupones);
  const addCuponesMasivosCanjeados = (cupones) =>
    setCuponesMasivosCanjeados(cupones);
  const setCurrentCuponMasivoSelected = (cupon: ValesData) => {
    setCurrentCuponMasivo(cupon);
  };
  const resetcuponMasivo = () => {
    setCurrentCuponMasivo(null);
  };
  const formaterFecha = (date: string, lenguage: string): string => {
    const dateWithOffset = date.replace(/(CEST|CET)/g, (match) => {
      return match === 'CEST' ? '+0200' : '+0100';
    });
    const timestamp = Date.parse(dateWithOffset);
    const newDate = new Date(timestamp);
    const isEuskera = lenguage === LanguageConstants.LOCALE_EUSKERA;
    if (isEuskera) {
      return format(newDate, 'yyyy/MM/dd HH:mm');
    }
    return format(newDate, 'dd/MM/yyyy HH:mm');
  };

  return (
    <ValesMasivosContext.Provider
      value={{
        cuponesMasivosActivables,
        cuponesMasivosActivados,
        cuponesMasivosCanjeados,
        addCuponesMasivosActivables,
        addCuponesMasivosActivados,
        addCuponesMasivosCanjeados,
        formaterFecha,
        setCurrentCuponMasivoSelected,
        currentCuponMasivo,
        resetcuponMasivo,
      }}
    >
      {children}
    </ValesMasivosContext.Provider>
  );
};

export const useValesMasivosContext = () => {
  const context = useContext(ValesMasivosContext);
  if (!context) {
    throw new Error(
      'useValesMasivosContext must be used within a ValesMasivosProvider',
    );
  }
  return context;
};
